











import Vue from "vue"

export default Vue.extend({
  props: {
    recruitmentLargeJobCategoryId: {
      type: Number,
      required: true,
    },
    headerImagePatternNo: {
      type: Number,
      required: true,
    },
    linkPath: {
      type: String,
      required: true,
    },
  },
})
